




import React from 'react';
import "./Spandan_Banner.css"
import Yellow_Btn from '../../common/common_btn/yellow_btn/Yellow_Btn';
import { useNavigate } from 'react-router-dom';
import { IDS } from '../../../utils/IDS';

function Spandan_Banner({ all_spandan }) {
  const navigate = useNavigate()

  return (
    <>
      <section className='Spandan_Banner_holder'>
        <div className="container">
          <div className='Spandan_Banner ' >
            <div className="banner_img_holder">
              <img src={`${IDS.IMG_URL + all_spandan?.Spandan?.image}`} className='banner_img' />
            </div>
            <div className="content_hodler">
              <h5>Join The Scared Flow <br />
                Join For The  Spandan Today</h5>
              <div className="Register_btn">
                <Yellow_Btn
                  btnText={"Register Now!"}
                  className='zoom_in_out'
                  onClick={() => { navigate("/spandan-register-form") }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Spandan_Banner;

